import { z } from 'zod'

const AccountTypes = z.enum(["checking", "savings"], {
  errorMap: () => ({ message: "Account type must be one of: 'Checking', or 'Saving." }),
});

// Function to validate the ABA routing number checksum
export const ExternalAccountSchema = z
  .object({
    account_nickname: z.string({ message: "Account Nickname must be a string" }).nonempty("Account Nickname cannot be empty"),
    account_holder_fullname: z.string({ message: "Account Holder Full Name must be a string" }).nonempty("Account Holder Full Name cannot be empty"),
    bank_name: z.string({ message: "Bank name must be a strong" }).nonempty("Bank name cannot be empty"),
    routing_number: z.string({ message: "Routing number must be a 9 digit number" }).nonempty("Routing number cannot be empty"),
    account_number: z.string({ message: "Account number must be a string" }).nonempty(),
    types: z.literal("Account"),
    accountType: AccountTypes,
  })
  .refine(
    (data) => {
      // Convert number to a string and pad with leading zeros if needed
      const routingStr = data.routing_number.padStart(9, "0");

      // Ensure it's exactly 9 digits
      if (!/^\d{9}$/.test(routingStr)) return false;

      // Apply the ABA checksum formula
      const digits = routingStr.split("").map(Number);
      const checksum = 3 * (digits[0] + digits[3] + digits[6]) + 7 * (digits[1] + digits[4] + digits[7]) + (digits[2] + digits[5] + digits[8]);

      return checksum % 10 === 0;
    },
    {
      path: ["routing_number"],
      message: "Invalid Routing Number",
    },
  );